<div class="d-flex align-items-center gap-3">
	<div
		class="participant-index-badge rounded-circle bg-secondary-subtle text-secondary-emphasis d-inline-flex justify-content-center align-items-center flex-shrink-0 lh-1"
	>
		{{ slotIndex() + 1 }}
	</div>
	<div class="d-flex flex-column">
		<mat-card-title class="mb-0 fs-6">
			@if (slot().userData) {
				{{ slot().userData.firstName }} {{ slot().userData.lastName }}
			} @else {
				Uczestnik {{ slotIndex() + 1 }}
			}
		</mat-card-title>
		<mat-card-subtitle class="text-muted small my-0 fw-normal">
			Liczba usług: {{ servicesCount() }} | Cena usług:
			<span class="fw-semibold">{{ servicesSum() | price }} PLN</span> | Łączna cena za uczestnika:
			<span class="fw-semibold">{{ participantTotalPrice() | price }} PLN</span>
		</mat-card-subtitle>
	</div>
</div>
<mat-divider class="mt-3"></mat-divider>
<div class="d-flex align-items-center gap-3 py-2 px-3">
	<span class="flex-shrink-0 text-nowrap">Wyrównanie ceny</span>
	<mat-form-field
		[appearance]="formFieldAppearance()"
		[subscriptSizing]="formFieldSubscriptSizing()"
		class="flex-grow-1 w-100 mb-0"
	>
		<input
			matInput
			type="number"
			placeholder="Wpisz wartość w PLN"
			[ngModel]="slot().priceAdjustment ? (slot().priceAdjustment | price) : null"
			(ngModelChange)="onPriceAdjustmentChange($event)"
		/>
	</mat-form-field>
</div>
<mat-divider></mat-divider>
@if (servicesCount() === 0) {
	<div class="d-flex justify-content-center align-items-center py-4">
		<span class="text-muted small fst-italic">Brak wybranych usług</span>
	</div>
} @else {
	@for (slotService of slot().slotServices; track $index; let isLast = $last) {
		<div class="d-flex justify-content-between align-items-center py-2 px-3">
			<div class="d-flex align-items-center gap-2">
				<button
					mat-icon-button
					type="button"
					class="d-inline-flex justify-content-center align-items-center fs-5 text-danger"
					(click)="onRemoveService($index)"
				>
					<i class="fa-solid fa-trash-can"></i>
				</button>
				<div class="d-flex flex-column">
					<span>{{ slotService.service?.name }}</span>
					<span
						class="badge rounded-pill bg-secondary-subtle text-secondary small fw-normal align-self-start"
					>
						{{ slotService.service?.serviceType?.name }}
					</span>
				</div>
			</div>
			<span class="fw-semibold">{{ slotService.price | price }} PLN</span>
		</div>
		@if (!isLast) {
			<mat-divider></mat-divider>
		}
	}
}
<mat-divider></mat-divider>
<div class="d-flex gap-2 align-items-center pt-3">
	<div class="flex-grow-1">
		<mat-form-field
			[appearance]="formFieldAppearance()"
			[subscriptSizing]="formFieldSubscriptSizing()"
			class="w-100"
		>
			<mat-label>Wybierz usługę</mat-label>
			<input
				matInput
				type="text"
				[formControl]="serviceControl()"
				[matAutocomplete]="participantServiceAutocomplete"
			/>
			<mat-autocomplete
				#participantServiceAutocomplete="matAutocomplete"
				(optionSelected)="onServiceSelected($event)"
			>
				@for (service of autocompleteOptions(); track service.id) {
					<mat-option [value]="service.name">{{ service.name }}</mat-option>
				}
			</mat-autocomplete>
		</mat-form-field>
	</div>
	<div class="flex-shrink-0">
		<button
			mat-raised-button
			color="primary"
			class="text-nowrap"
			[disabled]="!selectedServiceName()"
			(click)="onAddService()"
		>
			Dodaj
		</button>
	</div>
</div>
